import { useState } from 'react';
import { deleteAllContentInDraft } from '../helpers/deleteAllContentInDraft';
import { deleteAllImagesInDraft } from '../helpers/deleteAllImagesInDraft';
import { TextBlock } from '../interfaces/textEditor.interface';

export const useContentDeletion = () => {
  const [isDeleting, setIsDeleting] = useState(false);

  const deleteAllDraftContent = async (
    textBlocks: TextBlock[],
    userId: string,
    draftId: string,
    contentRef?: string,
  ) => {
    setIsDeleting(true);

    try {
      const results = await deleteAllContentInDraft(
        textBlocks,
        userId,
        draftId,
        contentRef,
      );

      // Log results
      const imagesFailed = results.imageResults.failed.length;
      const imagesSuccess = results.imageResults.success.length;
      const contentSuccess = results.contentResults.success;
      const contentError = results.contentResults.error;

      if (imagesFailed > 0 || contentError) {
        console.warn('Some content failed to delete:', {
          imagesFailed,
          contentError,
        });
      }

      return results;
    } catch (error) {
      console.error('Error during bulk content deletion:', error);
      throw error;
    } finally {
      setIsDeleting(false);
    }
  };

  const deleteDraftImages = async (textBlocks: TextBlock[]) => {
    setIsDeleting(true);

    try {
      const results = await deleteAllImagesInDraft(textBlocks);

      if (results.failed.length > 0) {
        console.warn(
          `Some images failed to delete: ${results.failed.length} out of ${results.success.length + results.failed.length}`,
        );
      }

      return results;
    } catch (error) {
      console.error('Error during bulk image deletion:', error);
      throw error;
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteAllDraftContent, deleteDraftImages, isDeleting };
};
